export default __webpack_public_path__ + "ab5383f0afe661a7f3e862e3fa3ac01e.png";